const envs = {
    // S3__BUCKET_CARD: 'chenbro-ecard',
    // S3__BUCKET_LOCATION: 'ap-northeast-1',
    // S3__QRCODE_DIR: 'qrcode',
    // S3__CARD_DIR: 'card',
    // URL: 'https://fw64l6bvf4.execute-api.ap-northeast-1.amazonaws.com',
    BACKEND_URL: 'https://7x7nt6z7r7.execute-api.ap-northeast-1.amazonaws.com'
    // URL: 'https://j2cjqmeoe0.execute-api.ap-northeast-1.amazonaws.com',
    // URL: 'http://localhost:5000',
}
export default envs;